
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hLSQl", function(module, exports) {
/**
 * @generated SignedSource<<bbb59c5c30ca67cb41776028b01d1e91>>
 * @relayHash d3cbb5679b7148d443553094e842e8cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 975565325d728076933658d2fe53e67e0cb762b2b175669521009eca0cb8d845
const $6a919b540a721282$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartButtonRuleOwnerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartButtonRuleOwnerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d3cbb5679b7148d443553094e842e8cb",
            "id": "975565325d728076933658d2fe53e67e0cb762b2b175669521009eca0cb8d845",
            "metadata": {},
            "name": "SmartButtonRuleOwnerQuery",
            "operationKind": "query",
            "text": "query SmartButtonRuleOwnerQuery($userId:ID!){user:confluence_atlassianUser(id:$userId){id,displayName,photos{value}}}"
        }
    };
}();
$6a919b540a721282$var$node.hash = "ada1fd585f01c87fb01f49af6e5a39b5";
var $6a919b540a721282$export$2e2bcd8739ae039 = $6a919b540a721282$var$node;



var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $fxBfz = parcelRequire("fxBfz");


var $9Begw = parcelRequire("9Begw");


var $9KNO1 = parcelRequire("9KNO1");


var $71D5r = parcelRequire("71D5r");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $aMcHK = parcelRequire("aMcHK");


var $4PPzL = parcelRequire("4PPzL");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $7aRa9 = parcelRequire("7aRa9");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $3jwuS = parcelRequire("3jwuS");


var $jMyy4 = parcelRequire("jMyy4");


var $dK51B = parcelRequire("dK51B");

const $e84e5a2acd0e1210$export$371932b402169c09 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/automation/internal-api/confluence/${variables.cloudId}/${variables.automationStack}/rest/${variables.spaceId}/rule/${variables.ruleId}/summary`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        parseResult: (response)=>({
                experimentalAutomationRuleSummary: {
                    id: response.id,
                    name: response.name,
                    authorAccountId: response.authorAccountId,
                    ruleState: response.ruleState,
                    componentSummaries: response.componentSummaries
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};



var $iz4WO = parcelRequire("iz4WO");


var $5xpFL = parcelRequire("5xpFL");





var $cddSi = parcelRequire("cddSi");




var $c31cf30ba7e02b51$export$5d7ba7f5550f99d1 = /*#__PURE__*/ function(ButtonState) {
    ButtonState["LOADING"] = "LOADING";
    ButtonState["RULE_DELETED"] = "RULE_DELETED";
    ButtonState["RULE_DISABLED"] = "RULE_DISABLED";
    ButtonState["RULE_MOVED"] = "RULE_MOVED";
    ButtonState["RULE_NOT_RUNNABLE"] = "RULE_NOT_RUNNABLE";
    ButtonState["INVALID_CONTENT_TYPE"] = "INVALID_CONTENT_TYPE";
    ButtonState["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    ButtonState["VIEW_RULE_NOT_CONFIGURED"] = "VIEW_RULE_NOT_CONFIGURED";
    ButtonState["MISSING_PERMISSIONS"] = "MISSING_PERMISSIONS";
    ButtonState["AI_DISABLED"] = "AI_DISABLED";
    ButtonState["EDIT_RULE_NOT_CONFIGURED"] = "EDIT_RULE_NOT_CONFIGURED";
    ButtonState["PREDEFINED_TEMPLATE_NOT_CONFIGURED"] = "PREDEFINED_TEMPLATE_NOT_CONFIGURED";
    ButtonState["EDIT_RULE_CONFIGURED"] = "EDIT_RULE_CONFIGURED";
    ButtonState["RULE_CONFIGURED"] = "RULE_CONFIGURED";
    return ButtonState;
}({});
const $c31cf30ba7e02b51$export$5973a816d97859fe = [
    "LOADING",
    "RULE_DELETED",
    "RULE_DISABLED",
    "RULE_MOVED",
    "RULE_NOT_RUNNABLE",
    "INVALID_CONTENT_TYPE",
    "NOT_AVAILABLE",
    "VIEW_RULE_NOT_CONFIGURED",
    "MISSING_PERMISSIONS",
    "AI_DISABLED"
];
const $c31cf30ba7e02b51$export$3c886446fcdbccc3 = [
    "EDIT_RULE_NOT_CONFIGURED",
    "RULE_CONFIGURED"
];
const $c31cf30ba7e02b51$export$90196fd853a65629 = [
    "EDIT_RULE_NOT_CONFIGURED",
    "PREDEFINED_TEMPLATE_NOT_CONFIGURED"
];
const $c31cf30ba7e02b51$export$ab177f9ef62e71eb = [
    "LOADING",
    "RULE_CONFIGURED",
    "VIEW_RULE_NOT_CONFIGURED"
];
const $c31cf30ba7e02b51$export$aedd5c4101f1dd14 = (buttonState)=>$c31cf30ba7e02b51$export$5973a816d97859fe.includes(buttonState) || buttonState === "EDIT_RULE_CONFIGURED" && (0, $9wGTI.fg)('a4c-enable-live-doc-smart-button');
const $c31cf30ba7e02b51$export$1f47d3ccd82194be = (buttonState)=>$c31cf30ba7e02b51$export$ab177f9ef62e71eb.includes(buttonState);
const $c31cf30ba7e02b51$export$420ca8f2a4b6774a = (buttonState)=>$c31cf30ba7e02b51$export$90196fd853a65629.includes(buttonState);


const $6bc6395ff1b02faf$export$bc1e1caf1db0296 = ({ automationRuleSummaryData: automationRuleSummaryData, automationRuleSummaryLoading: automationRuleSummaryLoading, isSmartButtonAllowed: isSmartButtonAllowed, contentType: contentType, isRunnableRule: isRunnableRule, isViewMode: isViewMode, isAdminHubAIEnabled: isAdminHubAIEnabled, ruleId: ruleId, spaceId: spaceId, scopeId: scopeId, predefinedTemplateId: predefinedTemplateId, isCurrentPageLive: isCurrentPageLive, error: error })=>{
    const automationRuleSummary = automationRuleSummaryData?.experimentalAutomationRuleSummary ?? undefined;
    const templateComponents = automationRuleSummary?.componentSummaries;
    const containsAIActions = templateComponents && templateComponents.some((component)=>component.type === 'confluence.generate-ai-action-items.action' || component.type === 'confluence.generate-ai-summary.action');
    if (automationRuleSummaryLoading) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).LOADING;
    else if (!isSmartButtonAllowed) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).NOT_AVAILABLE;
    else if (contentType !== 'page') return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).INVALID_CONTENT_TYPE;
    else if (!automationRuleSummary && ruleId) {
        // rule moved from another space
        if (spaceId !== scopeId) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_MOVED;
        else return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_DELETED;
    } else if (automationRuleSummary?.ruleState === (0, $cddSi.ExperimentalAutomationRuleState).DISABLED) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_DISABLED;
    else if (!isAdminHubAIEnabled && containsAIActions) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).AI_DISABLED;
    else if (!isViewMode) {
        // user is missing permissions to view rule config
        if (error) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).MISSING_PERMISSIONS;
        if (!ruleId) {
            if (!!predefinedTemplateId) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).PREDEFINED_TEMPLATE_NOT_CONFIGURED;
            else return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).EDIT_RULE_NOT_CONFIGURED;
        }
        // Allow button to be runnable in live page edit mode if it has all required info
        if (ruleId && isRunnableRule && isCurrentPageLive && (0, $9wGTI.fg)('a4c-enable-live-doc-smart-button')) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_CONFIGURED;
        return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).EDIT_RULE_CONFIGURED;
    } else if (ruleId && !isRunnableRule) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_NOT_RUNNABLE;
    else if (!ruleId) return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).VIEW_RULE_NOT_CONFIGURED;
    else return (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_CONFIGURED;
};











var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");








var $cs1vW = parcelRequire("cs1vW");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $1eaCJ = parcelRequire("1eaCJ");


var $79K6d = parcelRequire("79K6d");


var $k3mqd = parcelRequire("k3mqd");










var $gdv5Z = parcelRequire("gdv5Z");






var $ebrpi = parcelRequire("ebrpi");

const $257f04524a9142dc$var$i18n = (0, $h82at.defineMessages)({
    rulePreviewErrorMessage: {
        id: "automation-extensions.smart-button.rule-preview.error",
        defaultMessage: "We are having trouble loading this information."
    }
});
const $257f04524a9142dc$export$d3302126b7e5ae2a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        align: "start",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $257f04524a9142dc$var$i18n.rulePreviewErrorMessage))));






















var $lAFHW = parcelRequire("lAFHW");


var $av0Vd = parcelRequire("av0Vd");


var $8jHAi = parcelRequire("8jHAi");


var $ldfch = parcelRequire("ldfch");


var $1yB28 = parcelRequire("1yB28");


var $9Q2dU = parcelRequire("9Q2dU");


var $6767u = parcelRequire("6767u");


var $2MuFw = parcelRequire("2MuFw");


var $5tOl1 = parcelRequire("5tOl1");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $5tmwS = parcelRequire("5tmwS");


var $4GKfl = parcelRequire("4GKfl");


var $3Mg7y = parcelRequire("3Mg7y");







const $826d056416aba78a$export$e822885cca357efb = (componentType)=>{
    switch(componentType){
        case 'confluence.change-page-status.action':
        case 'confluence.create-page.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.add-label.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.add-comment.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'outgoing.email':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.restrict-page.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.change-page-owner.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.copy-page.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.move-page.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.update-data-classification.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'jira.issue.create':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                size: "small",
                label: "",
                appearance: "brand"
            });
        case 'confluence.generate-ai-summary.action':
        case 'confluence.generate-ai-action-items.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                testId: "atlassian-intelligence-icon",
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.create-database.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.create-whiteboard.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'confluence.create-folder.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                label: "",
                color: (0, $79K6d.getPrimaryColor)((0, $k3mqd.ComponentType).ACTION)
            });
        case 'rovo.invoke-agent.action':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                size: "small",
                label: "",
                appearance: "brand"
            });
    }
};


const $967cc4e0070d038a$export$258e9307166c08d7 = ({ componentType: componentType, componentName: componentName })=>{
    const Icon = (0, $826d056416aba78a$export$e822885cca357efb)(componentType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, Icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        align: "center",
        size: "medium"
    }, componentName)));
};


const $cb5da11dca1f027a$export$ce328a893ddb859b = ({ actionSummaries: actionSummaries })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, actionSummaries.map((summary)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $967cc4e0070d038a$export$258e9307166c08d7), {
            key: summary.type,
            componentType: summary.type,
            componentName: summary.componentName
        })));
};









var $kpYGL = parcelRequire("kpYGL");

const $3972ccbe58be7876$export$ef1ddcf09d324b1d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150",
        testId: "rule-preview-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "150px",
        height: "16px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "150px",
        height: "16px",
        isShimmering: true
    })));
};


const $7d065bd217b8a65d$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    whenButtonClicked: {
        id: "automation-extensions.smart-button.preview.when-clicked",
        defaultMessage: "When Smart button is clicked"
    },
    then: {
        id: "automation-extensions.smart-button.preview.then",
        defaultMessage: "Then"
    }
});
const $7d065bd217b8a65d$var$RulePreviewComponent = ({ automationRuleSummaryData: automationRuleSummaryData, automationRuleSummaryLoading: automationRuleSummaryLoading, automationRuleSummaryError: automationRuleSummaryError, intl: intl })=>{
    const automationRuleSummary = automationRuleSummaryData?.experimentalAutomationRuleSummary ?? undefined;
    if (automationRuleSummaryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $257f04524a9142dc$export$d3302126b7e5ae2a), null);
    if (automationRuleSummaryLoading || !automationRuleSummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3972ccbe58be7876$export$ef1ddcf09d324b1d), null);
    const { componentSummaries: componentSummaries } = automationRuleSummary;
    const actionSummaries = componentSummaries.filter((summary)=>summary.component === (0, $k3mqd.ComponentType).ACTION);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        backgroundColor: (0, $79K6d.getBackgroundColor)((0, $k3mqd.ComponentType).TRIGGER),
        paddingBlock: "space.025",
        paddingInline: "space.050",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            borderRadius: 'radius.small',
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        align: "center",
        color: (0, $79K6d.getTextColorByComponentType)((0, $k3mqd.ComponentType).TRIGGER),
        size: "small",
        weight: "semibold"
    }, intl.formatMessage($7d065bd217b8a65d$export$a7357cdd1f0b0168.whenButtonClicked))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        backgroundColor: (0, $79K6d.getBackgroundColor)((0, $k3mqd.ComponentType).ACTION),
        paddingBlock: "space.025",
        paddingInline: "space.050",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            borderRadius: 'radius.small',
            width: 'fit-content'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: (0, $79K6d.getTextColorByComponentType)((0, $k3mqd.ComponentType).ACTION),
        size: "small",
        weight: "semibold"
    }, intl.formatMessage($7d065bd217b8a65d$export$a7357cdd1f0b0168.then))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cb5da11dca1f027a$export$ce328a893ddb859b), {
        actionSummaries: actionSummaries
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AUTOMATION_SMART_BUTTON_PREVIEW_RULE)
    }));
};
const $7d065bd217b8a65d$export$2944f56d95de4198 = (0, $cs1vW.default)($7d065bd217b8a65d$var$RulePreviewComponent);


const $c1d46d82f3c2f0da$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    removedTooltip: {
        id: "automation-extensions.smart-button.tooltip.removed",
        defaultMessage: "Smart button has been removed. Contact your admin."
    },
    disabledTooltip: {
        id: "automation-extensions.smart-button.tooltip.disabled",
        defaultMessage: "Smart button has been disabled. Contact your admin."
    },
    movedTooltip: {
        id: "automation-extensions.smart-button.tooltip.moved",
        defaultMessage: "This smart button runs a rule in another space. Contact your admin."
    },
    premiumOnlyTooltip: {
        id: "automation-extensions.smart-button.tooltip.premium-only",
        defaultMessage: "Smart buttons are a Premium feature. Contact your admin."
    },
    pageOnlyTooltip: {
        id: "automation-extensions.smart-button.tooltip.page-only",
        defaultMessage: "Smart buttons don\u2019t work on blogs. We\u2019ve disabled this button."
    },
    unconfiguredTooltip: {
        id: "automation-extensions.smart-button.tooltip.unconfigured",
        defaultMessage: "This button doesn\u2019t have a rule configured. To create your own button, select the (+) icon from the toolbar or type /smart button."
    },
    missingPermissionsWithOwnerTooltip: {
        id: "automation-extensions.smart-button.tooltip.missing-permissions-with-owner",
        defaultMessage: "{userName} owns this rule and is the only one who can edit it."
    },
    missingPermissionsDefaultTooltip: {
        id: "automation-extensions.smart-button.tooltip.missing-permissions-default",
        defaultMessage: "This rule\u2019s owner is the only person who can edit it."
    },
    AIDisabledAndAIRuleTooltip: {
        id: "automation-extensions.smart-button.tooltip.ai-disabled-and-ai-rule-button",
        defaultMessage: "Smart button is disabled because your admin has turned off Atlassian Intelligence."
    },
    predefinedTemplateTooltip: {
        id: "automation-extensions.smart-button.tooltip.predefined-template.unconfigured",
        defaultMessage: "Button is not set up"
    },
    editModeUnconfiguredTooltip: {
        id: "automation-extensions.smart-button.tooltip.edit-mode.unconfigured",
        defaultMessage: "Button has no actions"
    },
    ruleNotRunnableTooltip: {
        id: "automation-extensions.smart-button.tooltip.rule-not-runnable",
        defaultMessage: "There was a problem and we couldn\u2019t run the automation. Refresh the page. Contact support if this persists."
    },
    clickToEdit: {
        id: "automation-extensions.smart-button.tooltip.click-to-edit",
        defaultMessage: "Click to edit"
    },
    selectToEdit: {
        id: "automation-extensions.smart-button.tooltip.select-to-edit",
        defaultMessage: "Select to edit"
    }
});
const $c1d46d82f3c2f0da$export$a9eabe0d85862b0f = ({ buttonState: buttonState, userName: userName, automationRuleSummaryData: automationRuleSummaryData, automationRuleSummaryLoading: automationRuleSummaryLoading, automationRuleSummaryError: automationRuleSummaryError })=>{
    switch(buttonState){
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_DELETED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.removedTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_DISABLED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.disabledTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_MOVED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.movedTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).NOT_AVAILABLE:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.premiumOnlyTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).INVALID_CONTENT_TYPE:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.pageOnlyTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).VIEW_RULE_NOT_CONFIGURED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                    space: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    size: "medium"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.unconfiguredTooltip)));
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).EDIT_RULE_NOT_CONFIGURED:
            return ()=>// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                    separator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "\xb7"),
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.editModeUnconfiguredTooltip), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.clickToEdit));
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).PREDEFINED_TEMPLATE_NOT_CONFIGURED:
            return ()=>// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                    separator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, "\xb7"),
                    space: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.predefinedTemplateTooltip), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.selectToEdit));
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).MISSING_PERMISSIONS:
            return ()=>userName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                    ...$c1d46d82f3c2f0da$export$a7357cdd1f0b0168.missingPermissionsWithOwnerTooltip,
                    values: {
                        userName: userName
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.missingPermissionsDefaultTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).LOADING:
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_CONFIGURED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d065bd217b8a65d$export$2944f56d95de4198), {
                    automationRuleSummaryData: automationRuleSummaryData,
                    automationRuleSummaryLoading: automationRuleSummaryLoading,
                    automationRuleSummaryError: automationRuleSummaryError
                });
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).AI_DISABLED:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.AIDisabledAndAIRuleTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).RULE_NOT_RUNNABLE:
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c1d46d82f3c2f0da$export$a7357cdd1f0b0168.ruleNotRunnableTooltip);
        case (0, $c31cf30ba7e02b51$export$5d7ba7f5550f99d1).EDIT_RULE_CONFIGURED:
            return;
        default:
            // If there is a TS error on this line, a ButtonState is not being handled in this switch statement.
            const exhaustiveCheck = buttonState;
            throw new Error(`Unhandled case: ${exhaustiveCheck}`);
    }
};














const $87acd1ce5c706900$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    ruleInvocationSuccessTitle: {
        id: "automation-extensions.flag.invocation.success.title",
        defaultMessage: "Your automation is in progress"
    },
    ruleInvocationFailureTitle: {
        id: "automation-extensions.flag.invocation.failure.title",
        defaultMessage: "Oops we ran into a problem"
    },
    ruleInvocationFailureDescription: {
        id: "automation-extensions.flag.invocation.failure.description",
        defaultMessage: "There was a problem and we couldn\u2019t run the automation"
    }
});
const $87acd1ce5c706900$var$INVOCATIONS = 'invocations';
const $87acd1ce5c706900$export$f4b03259b892c9f2 = (response)=>Object.keys(response).filter((object)=>object != $87acd1ce5c706900$var$INVOCATIONS && response[object] !== 'SUCCESS');
const $87acd1ce5c706900$export$857d474c6e4ecf24 = (experienceTracker, createAnalyticsEvent)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'runAutomationSmartButton',
            source: 'viewPageScreen'
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.AUTOMATION_SMART_BUTTON_RUN_RULE)
    });
};
const $87acd1ce5c706900$export$58202ebc9ab6b323 = (flags, experienceTracker)=>{
    flags.showInfoFlag({
        id: 'automation-manual-trigger-execution-finished-flag',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $87acd1ce5c706900$export$a7357cdd1f0b0168.ruleInvocationSuccessTitle),
        isAutoDismiss: true
    });
    experienceTracker.succeed({
        name: (0, $irVI7.AUTOMATION_SMART_BUTTON_RUN_RULE)
    });
};
const $87acd1ce5c706900$export$9cae823a0acea925 = (flags, experienceTracker, error, attributes)=>{
    flags.showErrorFlag({
        id: 'automation-manual-trigger-execution-finished-flag',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $87acd1ce5c706900$export$a7357cdd1f0b0168.ruleInvocationFailureTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $87acd1ce5c706900$export$a7357cdd1f0b0168.ruleInvocationFailureDescription),
        isAutoDismiss: true
    });
    experienceTracker.fail({
        name: (0, $irVI7.AUTOMATION_SMART_BUTTON_RUN_RULE),
        error: error,
        attributes: attributes
    });
};


const $17c8ffe3561d1a14$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    defaultSmartButtonName: {
        id: "automation-extensions.smart-button.default-smart-button-name",
        defaultMessage: "New button"
    },
    smartButtonExtensionTitle: {
        id: "automation-extensions.smart-button.extension-title",
        defaultMessage: "Smart Button"
    }
});
const $17c8ffe3561d1a14$var$SmartButtonRuleOwnerQuery = (0, $6a919b540a721282$export$2e2bcd8739ae039);
const $17c8ffe3561d1a14$var$getTooltipPosition = (buttonState)=>{
    if ((0, $c31cf30ba7e02b51$export$1f47d3ccd82194be)(buttonState)) {
        if ((0, $9wGTI.fg)('a4c-enable-live-doc-smart-button')) return 'right-start';
        return 'bottom-start';
    } else if ((0, $c31cf30ba7e02b51$export$420ca8f2a4b6774a)(buttonState)) return 'bottom-end';
    return 'top';
};
const $17c8ffe3561d1a14$var$tooltipStyle = null;
const $17c8ffe3561d1a14$var$TooltipContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(function TooltipContainer({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _1yt4utpp _bfhkvuon _syazi7uo _16qs130s _p12f1ijo"
        ])
    }, children);
});
const $17c8ffe3561d1a14$var$UnconfiguredIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Unconfigured icon"
    });
const $17c8ffe3561d1a14$export$463a5aae3c959279 = (0, $7aRa9.withFlags)(({ flags: flags, ruleId: ruleId, scopeId: scopeId, smartButtonName: smartButtonName, pageAri: pageAri, site: site, isViewMode: isViewMode, contentType: contentType, experienceTrackerName: experienceTrackerName, contentId: contentId, predefinedTemplateId: predefinedTemplateId })=>{
    const [invokingRuleId, setInvokingRuleId] = (0, $42omo.useState)(null);
    const [automationStack, setAutomationStack] = (0, $42omo.useState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { environment: environment, cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { error: error } = (0, $5xpFL.useEditRuleData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    (0, $42omo.useEffect)(()=>{
        if (isSmartButtonAllowed) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9KNO1.getAutomationStack)(environment).then((res)=>setAutomationStack(res));
    }, [
        environment,
        isSmartButtonAllowed
    ]);
    (0, $42omo.useEffect)(()=>{
        const mode = isViewMode ? (0, $5kjCz.RENDERER) : (0, $5kjCz.EDITOR);
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: experienceTrackerName
        });
    }, [
        isViewMode,
        contentId,
        experienceTrackerName
    ]);
    const mappedEnvironment = (0, $71D5r.mapEnv)(environment);
    const smartButtonNameIntl = smartButtonName ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $17c8ffe3561d1a14$export$a7357cdd1f0b0168.defaultSmartButtonName); // Allow button to be runnable in both view and edit modes if it has all required info
    const isRunnableRule = !!(ruleId && pageAri && site);
    const handleRule = async ()=>{
        if (isRunnableRule) {
            (0, $87acd1ce5c706900$export$857d474c6e4ecf24)(experienceTracker, createAnalyticsEvent);
            setInvokingRuleId(ruleId);
            try {
                // @ts-ignore
                // TODO A4C-3445: Remove this ignore once rule uuid strings are supported
                const response = await (0, $9Begw.invokeManuallyTriggeredRule)(mappedEnvironment, site, ruleId, [
                    pageAri
                ]);
                const failedObjects = (0, $87acd1ce5c706900$export$f4b03259b892c9f2)(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) (0, $87acd1ce5c706900$export$58202ebc9ab6b323)(flags, experienceTracker);
                else (0, $87acd1ce5c706900$export$9cae823a0acea925)(flags, experienceTracker, new Error('Failed to run automation rule'), {
                    failedObjects: JSON.stringify(failedObjects)
                });
            } catch (e) {
                (0, $87acd1ce5c706900$export$9cae823a0acea925)(flags, experienceTracker, e);
                setInvokingRuleId(null);
            }
        }
    };
    const { data: automationRuleSummaryData, loading: automationRuleSummaryLoading, error: automationRuleSummaryError } = (0, $e84e5a2acd0e1210$export$371932b402169c09)({
        skip: !ruleId || !automationStack || !spaceId,
        variables: {
            ruleId: ruleId || '',
            cloudId: cloudId,
            automationStack: automationStack || '',
            spaceId: spaceId || ''
        }
    });
    if (automationRuleSummaryError) {
        // 404s represent a deleted rule and not a failed experience
        if (!(0, $aMcHK.isStatusCodeError)(automationRuleSummaryError, '404')) experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_SMART_BUTTON_PREVIEW_RULE),
            error: automationRuleSummaryError
        });
        (0, $7Sm4c.markErrorAsHandled)(automationRuleSummaryError);
    }
    const accountId = automationRuleSummaryData?.experimentalAutomationRuleSummary?.authorAccountId;
    const { data: data } = (0, $jMyy4.useQueryInterop)($17c8ffe3561d1a14$var$SmartButtonRuleOwnerQuery, {
        skip: !accountId,
        variables: {
            userId: accountId || ''
        }
    });
    const userName = data?.user?.displayName;
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const buttonState = (0, $6bc6395ff1b02faf$export$bc1e1caf1db0296)({
        automationRuleSummaryData: automationRuleSummaryData,
        automationRuleSummaryLoading: automationRuleSummaryLoading,
        contentType: contentType,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isSmartButtonAllowed: isSmartButtonAllowed,
        isViewMode: isViewMode,
        ruleId: ruleId,
        scopeId: scopeId,
        spaceId: spaceId,
        isRunnableRule: isRunnableRule,
        predefinedTemplateId: predefinedTemplateId,
        isCurrentPageLive: isCurrentPageLive,
        error: error
    });
    const tooltipContent = (0, $c1d46d82f3c2f0da$export$a9eabe0d85862b0f)({
        buttonState: buttonState,
        userName: userName,
        automationRuleSummaryData: automationRuleSummaryData,
        automationRuleSummaryLoading: automationRuleSummaryLoading,
        automationRuleSummaryError: automationRuleSummaryError
    });
    const isButtonLoading = ruleId === invokingRuleId;
    const isButtonDisabled = (0, $c31cf30ba7e02b51$export$aedd5c4101f1dd14)(buttonState);
    const shouldUseCustomTooltipStyle = (0, $c31cf30ba7e02b51$export$1f47d3ccd82194be)(buttonState);
    const shouldShowUnconfiguredIcon = (0, $c31cf30ba7e02b51$export$420ca8f2a4b6774a)(buttonState);
    const tooltipPosition = $17c8ffe3561d1a14$var$getTooltipPosition(buttonState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        delay: 0,
        position: tooltipPosition,
        content: tooltipContent,
        component: shouldUseCustomTooltipStyle ? $17c8ffe3561d1a14$var$TooltipContainer : undefined
    }, (tooltipProps)=>{
        const { ...restTooltipProps } = tooltipProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ...restTooltipProps,
            onClick: handleRule,
            isDisabled: isButtonDisabled,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
            iconAfter: shouldShowUnconfiguredIcon ? $17c8ffe3561d1a14$var$UnconfiguredIcon : undefined,
            isLoading: isButtonLoading
        }, smartButtonNameIntl);
    });
});
const $17c8ffe3561d1a14$export$e846f1ef48df0d4e = (props)=>{
    const { isViewMode: isViewMode, contentId: contentId, experienceTrackerName: experienceTrackerName, ruleId: ruleId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: (errorProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorComponent), errorProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
                name: experienceTrackerName,
                contentId: contentId,
                mode: isViewMode ? (0, $5kjCz.RENDERER) : (0, $5kjCz.EDITOR),
                error: errorProps.error,
                attributes: {
                    ruleId: ruleId
                }
            })),
        attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17c8ffe3561d1a14$export$463a5aae3c959279, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.AUTOMATION_SMART_BUTTON_PREVIEW_RULE)
    }));
};
module.exports["i18n"] = $17c8ffe3561d1a14$export$a7357cdd1f0b0168;
module.exports["SmartButtonComponent"] = $17c8ffe3561d1a14$export$463a5aae3c959279;
module.exports["SmartButton"] = $17c8ffe3561d1a14$export$e846f1ef48df0d4e;

});

parcelRegister("9Begw", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4srqz = parcelRequire("4srqz");

const $66d0663e92004e81$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $4srqz.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $4srqz.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    // Feature gate: use UUID-based IDs if enabled, otherwise use numeric IDs
    const useUuid = (0, $dh538.fg)('mits-533-switch-manual-rules-to-uuids');
    return response.reduce((acc, { id: id, idUuid: idUuid, name: name, ruleScope: ruleScope, userInputs: userInputs })=>{
        const ruleId = useUuid ? idUuid : id.toString();
        return {
            // eslint-disable-next-line
            ...acc,
            [ruleId]: {
                id: ruleId,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        };
    }, {});
};
const $66d0663e92004e81$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $4srqz.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $4srqz.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};
module.exports["searchManuallyTriggeredRules"] = $66d0663e92004e81$export$11e317ae81dd4223;
module.exports["invokeManuallyTriggeredRule"] = $66d0663e92004e81$export$9a0eb4136c6b46c;

});

parcelRegister("4srqz", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7MEO5 = parcelRequire("7MEO5");


var $g0I84 = parcelRequire("g0I84");

const $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $7MEO5.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch  {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $5f10a0d24e5e0ad1$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g0I84.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $5f10a0d24e5e0ad1$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g0I84.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $5f10a0d24e5e0ad1$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $5f10a0d24e5e0ad1$var$_performRequest = async (url, method, options = {
    headers: $5f10a0d24e5e0ad1$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $5f10a0d24e5e0ad1$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $5f10a0d24e5e0ad1$var$_performRequest(url, 'GET', options);
};
const $5f10a0d24e5e0ad1$export$692a4d9808143175 = async (url, options)=>{
    return $5f10a0d24e5e0ad1$var$_performRequest(url, 'POST', options);
};
const $5f10a0d24e5e0ad1$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'customer_service' && (0, $dh538.fg)('jcs_project_type_m3')) return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};
module.exports["getSearchUrl"] = $5f10a0d24e5e0ad1$export$7d4675b206f57488;
module.exports["getInvocationUrl"] = $5f10a0d24e5e0ad1$export$e62dcf5e32cec4bf;
module.exports["performPostRequest"] = $5f10a0d24e5e0ad1$export$692a4d9808143175;

});

parcelRegister("g0I84", function(module, exports) {
const $257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $257b51498dbf0a52$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $257b51498dbf0a52$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($257b51498dbf0a52$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$257b51498dbf0a52$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $257b51498dbf0a52$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $257b51498dbf0a52$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $257b51498dbf0a52$export$48cdb3ba720a47f6 = ()=>$257b51498dbf0a52$var$_getAutomationKeyFromLocalStorage($257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $257b51498dbf0a52$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $257b51498dbf0a52$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $257b51498dbf0a52$var$getAutomationDevStackFromLocalServer() || $257b51498dbf0a52$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};
module.exports["getAutomationStack"] = $257b51498dbf0a52$export$6123178d3f5fb24d;

});

parcelRegister("71D5r", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $abcb2d5b68c96c49$export$2f2beb3dfc4bcd87 = (env)=>{
    switch(env){
        case 'DEVELOPMENT':
            return 'dev';
        case 'PRODUCTION':
            return (0, $9wGTI.fg)('automation-dev-helper') ? 'pre-prod' : 'prod';
        case 'STAGING':
            return 'staging';
        default:
            return 'local';
    }
};
module.exports["mapEnv"] = $abcb2d5b68c96c49$export$2f2beb3dfc4bcd87;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});

parcelRegister("5xpFL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9KNO1 = parcelRequire("9KNO1");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $daeaba5653491822$export$c59ad6e8cab7e28e = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/automation/internal-api/confluence/${variables.cloudId}/${variables.automationStack}/rest/${variables.spaceId}/rule/${variables.ruleId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        credentials: 'include',
        parseResult: (response)=>({
                experimentalGetAutomationRuleById: {
                    id: response.id,
                    idUuid: response.idUuid,
                    clientKey: response.clientKey,
                    name: response.name,
                    state: response.state,
                    description: response.description,
                    authorAccountId: response.authorAccountId,
                    actor: response.actor,
                    created: response.created,
                    updated: response.updated,
                    trigger: response.trigger,
                    components: response.components,
                    canOtherRuleTrigger: response.canOtherRuleTrigger,
                    notifyOnError: response.notifyOnError,
                    projects: response.projects,
                    labels: response.labels,
                    tags: response.tags,
                    ruleScope: response.ruleScope,
                    ruleHome: response.ruleHome,
                    writeAccessType: response.writeAccessType,
                    collaborators: response.collaborators,
                    billingType: response.billingType
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};


const $6bc6f7b57a07dd37$var$getTemplateFormDataFromRuleConfigByTemplateId = (ruleConfig, templateId)=>{
    if (!ruleConfig?.components || !templateId) return {};
    const { components: components } = ruleConfig;
    const formData = {};
    components.forEach((component)=>{
        switch(component?.type){
            case 'confluence.change-page-status.action':
                formData.changePageStatusActionConfig = {
                    ...component.value
                };
                break;
            case 'outgoing.email':
                // component.value has more fields than the config wants, but doesn't seem to be an issue?
                formData.outgoingEmailActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.add-label.action':
                formData.addLabelActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.add-comment.action':
                formData.addCommentActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.create-page.action':
                formData.createPageActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.restrict-page.action':
                formData.restrictPageActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.change-page-owner.action':
                formData.changePageOwnerActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.copy-page.action':
                formData.copyPageActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.move-page.action':
                formData.movePageActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.update-data-classification.action':
                formData.updateDataClassificationActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.generate-ai-summary.action':
                formData.generateAISummaryActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.generate-ai-action-items.action':
                formData.generateAIActionItemsActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.create-database.action':
                formData.createDatabaseActionConfig = {
                    ...component.value
                };
                break;
            case 'jira.issue.create':
                delete component.value['advancedFields'];
                delete component.value['sendNotifications'];
                formData.createJiraIssueActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.create-whiteboard.action':
                formData.createWhiteboardActionConfig = {
                    ...component.value
                };
                break;
            case 'confluence.create-folder.action':
                formData.createFolderActionConfig = {
                    ...component.value
                };
                break;
            case 'rovo.invoke-agent.action':
                formData.invokeAgentActionConfig = {
                    ...component.value
                };
                break;
        }
    });
    return formData;
};
const $6bc6f7b57a07dd37$var$removeTypenameFields = (value)=>{
    if (value === null || value === undefined) return value;
    else if (Array.isArray(value)) return value.map((v)=>$6bc6f7b57a07dd37$var$removeTypenameFields(v));
    else if (typeof value === 'object') {
        const newObj = {};
        Object.entries(value).forEach(([key, v])=>{
            if (key !== '__typename') newObj[key] = $6bc6f7b57a07dd37$var$removeTypenameFields(v);
        });
        return newObj;
    }
    return value;
};
const $6bc6f7b57a07dd37$var$getCanEditRule = ({ isRuleOwner: isRuleOwner, ruleId: ruleId, isTemplateEditor: isTemplateEditor })=>{
    if (isTemplateEditor) return false;
    return !ruleId || isRuleOwner;
};
const $6bc6f7b57a07dd37$var$EditRuleContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isLoading: false,
    isTemplateEditor: false,
    canEditRule: false,
    ruleDetails: undefined,
    editSmartRuleTemplateId: null,
    editSmartRuleConfig: {},
    error: undefined
});
const $6bc6f7b57a07dd37$export$692afa421b7fcbbd = ({ ruleId: ruleId, isTemplateEditor: isTemplateEditor, children: children })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey ?? '');
    const [automationStack, setAutomationStack] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9KNO1.getAutomationStack)(environment).then((res)=>setAutomationStack(res));
    }, [
        environment
    ]);
    const { loading: loading, data: data, error: error } = (0, $daeaba5653491822$export$c59ad6e8cab7e28e)({
        skip: !ruleId || !automationStack || !spaceId,
        fetchPolicy: 'cache-and-network',
        variables: {
            ruleId: ruleId ?? '',
            spaceId: spaceId ?? '',
            cloudId: cloudId,
            automationStack: automationStack ?? ''
        }
    });
    if (error) {
        experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_SMART_BUTTON_EDIT_RULE),
            error: error
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const ruleDetails = data?.experimentalGetAutomationRuleById;
    const templateId = ruleDetails?.tags?.find((tag)=>tag?.tagType === 'TEMPLATE_ID')?.tagValue;
    const templateFormData = $6bc6f7b57a07dd37$var$getTemplateFormDataFromRuleConfigByTemplateId(ruleDetails, templateId);
    const isRuleOwner = ruleDetails?.authorAccountId === userId;
    const canEditRule = $6bc6f7b57a07dd37$var$getCanEditRule({
        isRuleOwner: isRuleOwner,
        ruleId: ruleId,
        isTemplateEditor: isTemplateEditor
    });
    const contextValue = (0, $42omo.useMemo)(()=>({
            isLoading: loading,
            isTemplateEditor: isTemplateEditor,
            canEditRule: canEditRule,
            editSmartRuleTemplateId: templateId,
            editSmartRuleConfig: templateFormData,
            // TODO: should be improved with official GQL mutation that doesn't require entire rule to make updates
            ruleDetails: $6bc6f7b57a07dd37$var$removeTypenameFields({
                ...ruleDetails
            }),
            error: error
        }), [
        templateFormData,
        loading,
        templateId,
        error,
        ruleDetails,
        canEditRule,
        isTemplateEditor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6bc6f7b57a07dd37$var$EditRuleContext.Provider, {
        value: contextValue
    }, children);
};
const $6bc6f7b57a07dd37$export$309140eebfd96a5c = ()=>{
    const context = (0, $42omo.useContext)($6bc6f7b57a07dd37$var$EditRuleContext);
    if (context === undefined) throw new Error('useEditRuleData must be used within a EditSmartButtonRuleProvider');
    return context;
};
module.exports["EditSmartButtonRuleProvider"] = $6bc6f7b57a07dd37$export$692afa421b7fcbbd;
module.exports["useEditRuleData"] = $6bc6f7b57a07dd37$export$309140eebfd96a5c;

});

parcelRegister("cddSi", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $c2f46ff20c3b9f41$export$e6329f6434453cd9 = /*#__PURE__*/ function(ExperimentalAutomationRuleState) {
    ExperimentalAutomationRuleState["DISABLED"] = "DISABLED";
    ExperimentalAutomationRuleState["ENABLED"] = "ENABLED";
    ExperimentalAutomationRuleState["NEW"] = "NEW";
    return ExperimentalAutomationRuleState;
}({});
module.exports["ExperimentalAutomationRuleState"] = $c2f46ff20c3b9f41$export$e6329f6434453cd9;

});

parcelRegister("79K6d", function(module, exports) {

var $k3mqd = parcelRequire("k3mqd");

const $7cffdae7fd7f000f$export$4420ac7a34197e42 = (componentType)=>{
    switch(componentType){
        case (0, $k3mqd.ComponentType).TRIGGER:
            return 'color.background.accent.green.subtlest';
        case (0, $k3mqd.ComponentType).ACTION:
            return 'color.background.accent.blue.subtlest';
    }
};
const $7cffdae7fd7f000f$export$2cf436d3baf8485c = (componentType)=>{
    switch(componentType){
        case (0, $k3mqd.ComponentType).TRIGGER:
            return "var(--ds-icon-accent-green, #22A06B)";
        case (0, $k3mqd.ComponentType).ACTION:
            return "var(--ds-icon-accent-blue, #357DE8)";
    }
};
const $7cffdae7fd7f000f$export$f543c7688a142e9b = (componentType)=>{
    switch(componentType){
        case (0, $k3mqd.ComponentType).TRIGGER:
            return 'color.text.success';
        case (0, $k3mqd.ComponentType).ACTION:
            return 'color.text.accent.blue';
    }
};
module.exports["getBackgroundColor"] = $7cffdae7fd7f000f$export$4420ac7a34197e42;
module.exports["getPrimaryColor"] = $7cffdae7fd7f000f$export$2cf436d3baf8485c;
module.exports["getTextColorByComponentType"] = $7cffdae7fd7f000f$export$f543c7688a142e9b;

});

parcelRegister("k3mqd", function(module, exports) {

var $h82at = parcelRequire("h82at");


var $ldfch = parcelRequire("ldfch");


var $8jHAi = parcelRequire("8jHAi");


var $av0Vd = parcelRequire("av0Vd");


var $9Q2dU = parcelRequire("9Q2dU");


var $6767u = parcelRequire("6767u");


var $2MuFw = parcelRequire("2MuFw");


var $5tOl1 = parcelRequire("5tOl1");


var $4GKfl = parcelRequire("4GKfl");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $5tmwS = parcelRequire("5tmwS");


var $1yB28 = parcelRequire("1yB28");


var $3Mg7y = parcelRequire("3Mg7y");


var $Ij2L0 = parcelRequire("Ij2L0");


var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");

const $ab31546c3d2f6b9a$export$ac34d1127f031fa3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        ...props,
        appearance: "brand",
        size: "small"
    });








const $804a74761fc0cc9f$export$1675665726341d95 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        ...props,
        appearance: "brand",
        size: "small"
    });



var $aMA7j = parcelRequire("aMA7j");

var $7e1f2471958e5b4b$export$347a461a27e813a2 = /*#__PURE__*/ function(ComponentType) {
    ComponentType["TRIGGER"] = "TRIGGER";
    ComponentType["ACTION"] = "ACTION";
    return ComponentType;
}({});
const $7e1f2471958e5b4b$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    changePageStatusAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.change-page-status-and-send-email.description",
        defaultMessage: "Change the page\u2019s status and send an email"
    },
    publishNewPageAndAddLabelDescription: {
        id: "automation-extensions.smart-button.template-card.publish-new-page-and-add-label.description",
        defaultMessage: "Publish a new page and add label(s)"
    },
    addLabelAndChangePageStatusDescription: {
        id: "automation-extensions.smart-button.template-card.add-label-and-change-page-status.description",
        defaultMessage: "Add label(s) and change the page\u2019s status"
    },
    changePageRestrictionsAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.change-page-restrictions-and-send-email.description",
        defaultMessage: "Change the page\u2019s restrictions and send an email"
    },
    changePageOwnerAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.change-page-owner-and-send-email.description",
        defaultMessage: "Change the page owner and send an email"
    },
    copyPageAndChangeOwnerAndStatusAndRestrictionsDescription: {
        id: "automation-extensions.smart-button.template-card.copy-page-and-change-owner-and-status-and-restrictions.description",
        defaultMessage: "Copy the page, change the page owner, the page\u2019s status, and the page\u2019s restrictions"
    },
    publishPageAndChangeOwnerAndStatusAndRestrictionsDescription: {
        id: "automation-extensions.smart-button.template-card.publish-page-and-change-owner-and-status-and-restrictions.description",
        defaultMessage: "Publish a new page, change the page owner, the page\u2019s status, and the page\u2019s restrictions"
    },
    // New templates
    movePageAndAddLabelDescription: {
        id: "automation-extensions.smart-button.template-card.move-page-and-add-label.description",
        defaultMessage: "Move page and add label"
    },
    updateDataClassificationAndChangeRestrictionsAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.update-data-classification-and-change-restrictions-and-send-email.description",
        defaultMessage: "Update data classification, change restrictions, and send email"
    },
    summarizeWithAIAndGenerateAIActionItemsAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.summarize-with-ai-and-generate-ai-action-items-and-send-email.description",
        defaultMessage: "Summarize with AI, Generate AI action items, and send email"
    },
    createDatabaseAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.create-database-and-send-email.description",
        defaultMessage: "Create database and send email"
    },
    createWhiteboardAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.create-whiteboard-and-send-email.description",
        defaultMessage: "Create whiteboard and send email"
    },
    publishNewPageAddLabelCreateJiraIssueDescription: {
        id: "automation-extensions.smart-button.template-card.publish-new-page-add-label-create-jira-issue.description",
        defaultMessage: "Publish a new page, add a label, and create issue in Jira"
    },
    createFolderAndPublishNewPageDescription: {
        id: "automation-extensions.smart-button.template-card.create-folder-and-publish-new-page.description",
        defaultMessage: "Create folder and publish new page"
    },
    invokeAgentAndPublishNewPageDescription: {
        id: "automation-extensions.smart-button.template-card.invoke-agent-and-publish-new-page.description",
        defaultMessage: "Use Rovo agent and publish new page"
    },
    invokeAgentAndSendEmailDescription: {
        id: "automation-extensions.smart-button.template-card.invoke-agent-and-send-email.description",
        defaultMessage: "Use Rovo agent and send email"
    },
    invokeAgentAndAddCommentDescription: {
        id: "automation-extensions.smart-button.template-card.invoke-agent-and-add-comment.description",
        defaultMessage: "Use Rovo agent and add comment"
    }
});
const $7e1f2471958e5b4b$export$7522abab9a867f0c = [
    {
        id: (0, $aMA7j.TemplateId).changePageStatusAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.changePageStatusAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).publishNewPageAndAddLabel,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.publishNewPageAndAddLabelDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($av0Vd)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).addLabelAndChangePageStatus,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.addLabelAndChangePageStatusDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($av0Vd)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).changePageRestrictionsAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.changePageRestrictionsAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).changePageOwnerAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.changePageOwnerAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6767u)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).copyPageAndChangeOwnerAndStatusAndRestrictions,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.copyPageAndChangeOwnerAndStatusAndRestrictionsDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6767u)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).publishPageAndChangeOwnerAndStatusAndRestrictions,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.publishPageAndChangeOwnerAndStatusAndRestrictionsDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6767u)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU)))
            }
        ]
    }
];
const $7e1f2471958e5b4b$export$3629e9bec73b243 = {
    id: (0, $aMA7j.TemplateId).summarizeWithAIAndGenerateAIActionItemsAndSendEmail,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.summarizeWithAIAndGenerateAIActionItemsAndSendEmailDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y)))
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y)))
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
        }
    ]
};
const $7e1f2471958e5b4b$export$67d14e46fde4d110 = [
    {
        id: (0, $aMA7j.TemplateId).movePageAndAddLabel,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.movePageAndAddLabelDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($av0Vd)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).updateDataClassificationAndChangeRestrictionsAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.updateDataClassificationAndChangeRestrictionsAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4GKfl)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).createDatabaseAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.createDatabaseAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    },
    {
        id: (0, $aMA7j.TemplateId).createWhiteboardAndSendEmail,
        description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.createWhiteboardAndSendEmailDescription,
        icons: [
            {
                componentType: "TRIGGER",
                icon: (0, $Ij2L0.ManualTriggerIcon),
                isCustomIcon: true
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z)))
            },
            {
                componentType: "ACTION",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
            }
        ]
    }
];
const $7e1f2471958e5b4b$export$5cd3d0c9a9fdadc2 = {
    id: (0, $aMA7j.TemplateId).createFolderAndPublishNewPage,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.createFolderAndPublishNewPageDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS)))
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
        }
    ]
};
const $7e1f2471958e5b4b$export$a579817371b9071d = {
    id: (0, $aMA7j.TemplateId).publishNewPageAddLabelCreateJiraIssue,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.publishNewPageAddLabelCreateJiraIssueDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($av0Vd)))
        },
        {
            componentType: "ACTION",
            icon: (0, $ab31546c3d2f6b9a$export$ac34d1127f031fa3)
        }
    ]
};
const $7e1f2471958e5b4b$export$3ea81e9db6a336ab = {
    id: (0, $aMA7j.TemplateId).invokeAgentAndPublishNewPage,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.invokeAgentAndPublishNewPageDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, $804a74761fc0cc9f$export$1675665726341d95)
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi)))
        }
    ]
};
const $7e1f2471958e5b4b$export$be24d9934f67d72 = {
    id: (0, $aMA7j.TemplateId).invokeAgentAndSendEmail,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.invokeAgentAndSendEmailDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, $804a74761fc0cc9f$export$1675665726341d95)
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch)))
        }
    ]
};
const $7e1f2471958e5b4b$export$4f687a9e3b0863c7 = {
    id: (0, $aMA7j.TemplateId).invokeAgentAndAddComment,
    description: $7e1f2471958e5b4b$export$a7357cdd1f0b0168.invokeAgentAndAddCommentDescription,
    icons: [
        {
            componentType: "TRIGGER",
            icon: (0, $Ij2L0.ManualTriggerIcon),
            isCustomIcon: true
        },
        {
            componentType: "ACTION",
            icon: (0, $804a74761fc0cc9f$export$1675665726341d95)
        },
        {
            componentType: "ACTION",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28)))
        }
    ]
};
module.exports["ComponentType"] = $7e1f2471958e5b4b$export$347a461a27e813a2;
module.exports["templateCardConfigs"] = $7e1f2471958e5b4b$export$7522abab9a867f0c;
module.exports["AITemplateCardConfig"] = $7e1f2471958e5b4b$export$3629e9bec73b243;
module.exports["newTemplateCardConfigs"] = $7e1f2471958e5b4b$export$67d14e46fde4d110;
module.exports["createFolderTemplateConfig"] = $7e1f2471958e5b4b$export$5cd3d0c9a9fdadc2;
module.exports["createJiraIssueTemplateConfig"] = $7e1f2471958e5b4b$export$a579817371b9071d;
module.exports["invokeAgentAndPublishNewPageTemplateConfig"] = $7e1f2471958e5b4b$export$3ea81e9db6a336ab;
module.exports["invokeAgentAndSendEmailTemplateConfig"] = $7e1f2471958e5b4b$export$be24d9934f67d72;
module.exports["invokeAgentAndAddCommentTemplateConfig"] = $7e1f2471958e5b4b$export$4f687a9e3b0863c7;

});

parcelRegister("Ij2L0", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $637dceea82563eb1$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $637dceea82563eb1$var$svgStyles = null;
const $637dceea82563eb1$export$1ba9c8c8d09e7b3f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { label: label, size: t1, primaryColor: t2, secondaryColor: secondaryColor } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const primaryColor = t2 === undefined ? "currentColor" : t2;
    let t3;
    if ($[0] !== primaryColor || $[1] !== secondaryColor) {
        t3 = {
            color: primaryColor,
            fill: secondaryColor
        };
        $[0] = primaryColor;
        $[1] = secondaryColor;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = label || undefined;
    const t5 = label ? "img" : "presentation";
    const t6 = $637dceea82563eb1$var$sizeStyles[size];
    let t7;
    if ($[3] !== t6) {
        t7 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            t6
        ]);
        $[3] = t6;
        $[4] = t7;
    } else t7 = $[4];
    let t10;
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
            fill: "currentColor"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd"
        });
        $[5] = t10;
        $[6] = t8;
        $[7] = t9;
    } else {
        t10 = $[5];
        t8 = $[6];
        t9 = $[7];
    }
    let t11;
    if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 24 24",
            style: t3,
            "aria-label": t4,
            role: t5,
            className: t7
        }, t8, t9, t10);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t7;
        $[12] = t11;
    } else t11 = $[12];
    return t11;
} : ({ label: label, size: size = 'medium', primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $637dceea82563eb1$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
module.exports["ManualTriggerIcon"] = $637dceea82563eb1$export$1ba9c8c8d09e7b3f;

});

parcelRegister("aMA7j", function(module, exports) {

var $jSkFe = parcelRequire("jSkFe");

var $6e4f31abf0bf2d9f$export$f1921b45c66f982c = /*#__PURE__*/ function(ValueType) {
    ValueType["ID"] = "ID";
    ValueType["NAME"] = "NAME";
    ValueType["COPY"] = "COPY";
    ValueType["ADD"] = "ADD";
    ValueType["REFERENCE"] = "REFERENCE";
    ValueType["SMART"] = "SMART";
    ValueType["SAME"] = "SAME";
    ValueType["FREE"] = "FREE";
    ValueType["AUTO"] = "AUTO";
    ValueType["CLEAR"] = "CLEAR";
    ValueType["ANY"] = "ANY";
    ValueType["GROUP_ID"] = "GROUP_ID";
    return ValueType;
}({});
var $6e4f31abf0bf2d9f$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["page"] = "page";
    ConfluenceContentType["blogpost"] = "blogpost";
    ConfluenceContentType["attachment"] = "attachment";
    ConfluenceContentType["content"] = "content";
    ConfluenceContentType["comment"] = "comment";
    ConfluenceContentType["embed"] = "embed";
    ConfluenceContentType["whiteboard"] = "whiteboard";
    return ConfluenceContentType;
}({});
const $6e4f31abf0bf2d9f$export$1f558dbc17fdb31d = (intl)=>({
        id: 'same-space-as-trigger',
        key: 'same-space-as-trigger',
        label: intl.formatMessage((0, $jSkFe.i18n).sameSpaceAsTrigger),
        containsExternalCollaborators: false,
        isUnknownSpace: true
    });
var $6e4f31abf0bf2d9f$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["ANYONE_CAN_VIEW_AND_EDIT"] = "ANYONE_CAN_VIEW_AND_EDIT";
    ContentRestrictionType["ANYONE_CAN_VIEW_RESTRICTED_EDIT"] = "ANYONE_CAN_VIEW_RESTRICTED_EDIT";
    ContentRestrictionType["RESTRICTED_VIEW_AND_EDIT"] = "RESTRICTED_VIEW_AND_EDIT";
    return ContentRestrictionType;
}({});
const $6e4f31abf0bf2d9f$export$2a997aa5c6f8ea65 = [
    {
        value: "ANYONE_CAN_VIEW_AND_EDIT",
        label: ()=>'Anyone in the space can view and edit'
    },
    {
        value: "ANYONE_CAN_VIEW_RESTRICTED_EDIT",
        label: ()=>'Anyone in the space can view, only some can edit'
    },
    {
        value: "RESTRICTED_VIEW_AND_EDIT",
        label: ()=>'Only specific people can view or edit'
    }
];
var $6e4f31abf0bf2d9f$export$2c31b482709f834f = /*#__PURE__*/ function(IssueFieldValueType) {
    IssueFieldValueType["ID"] = "ID";
    return IssueFieldValueType;
}({});
var $6e4f31abf0bf2d9f$export$7ea791c87396b818 = /*#__PURE__*/ function(IssueFieldOperation) {
    IssueFieldOperation["SET"] = "SET";
    IssueFieldOperation["ADD"] = "ADD";
    IssueFieldOperation["ADDREMOVE"] = "ADDREMOVE";
    IssueFieldOperation["REMOVE"] = "REMOVE";
    IssueFieldOperation["COPY"] = "COPY";
    return IssueFieldOperation;
}({});
var $6e4f31abf0bf2d9f$export$9c696cb525e5ed55 = /*#__PURE__*/ function(TemplateId) {
    TemplateId["changePageStatusAndSendEmail"] = "confluence_end_user_template_1";
    TemplateId["publishNewPageAndAddLabel"] = "confluence_end_user_template_2";
    TemplateId["addLabelAndChangePageStatus"] = "confluence_end_user_template_3";
    TemplateId["changePageRestrictionsAndSendEmail"] = "confluence_end_user_template_4";
    TemplateId["changePageOwnerAndSendEmail"] = "confluence_end_user_template_5";
    // 6 is listed on the project page but not designs
    TemplateId["changePageStatusAndRestrictionsAndSendEmail"] = "confluence_end_user_template_6";
    TemplateId["copyPageAndChangeOwnerAndStatusAndRestrictions"] = "confluence_end_user_template_7";
    TemplateId["publishPageAndChangeOwnerAndStatusAndRestrictions"] = "confluence_end_user_template_8";
    // new templates
    TemplateId["movePageAndAddLabel"] = "confluence_end_user_template_9";
    TemplateId["updateDataClassificationAndChangeRestrictionsAndSendEmail"] = "confluence_end_user_template_10";
    TemplateId["summarizeWithAIAndGenerateAIActionItemsAndSendEmail"] = "confluence_end_user_template_11";
    TemplateId["createDatabaseAndSendEmail"] = "confluence_end_user_template_12";
    TemplateId["createWhiteboardAndSendEmail"] = "confluence_end_user_template_13";
    TemplateId["publishNewPageAddLabelCreateJiraIssue"] = "confluence_end_user_template_14";
    TemplateId["createFolderAndPublishNewPage"] = "confluence_end_user_template_15";
    // new rovo templates
    TemplateId["invokeAgentAndPublishNewPage"] = "confluence_end_user_template_16";
    TemplateId["invokeAgentAndSendEmail"] = "confluence_end_user_template_17";
    TemplateId["invokeAgentAndAddComment"] = "confluence_end_user_template_18";
    return TemplateId;
}({});
const $6e4f31abf0bf2d9f$export$3e6c81cf13716aea = [
    "confluence_end_user_template_11",
    "confluence_end_user_template_16",
    "confluence_end_user_template_17",
    "confluence_end_user_template_18"
];
var $6e4f31abf0bf2d9f$export$ae77e0661f173b68 = /*#__PURE__*/ function(ContentStateRestrictionLevel) {
    ContentStateRestrictionLevel["NONE"] = "NONE";
    ContentStateRestrictionLevel["PAGE_OWNER"] = "PAGE_OWNER";
    return ContentStateRestrictionLevel;
}({});
module.exports["ValueType"] = $6e4f31abf0bf2d9f$export$f1921b45c66f982c;
module.exports["getSameSpaceAsTriggerOption"] = $6e4f31abf0bf2d9f$export$1f558dbc17fdb31d;
module.exports["ContentRestrictionType"] = $6e4f31abf0bf2d9f$export$91111a1ebace330;
module.exports["contentRestrictionOptions"] = $6e4f31abf0bf2d9f$export$2a997aa5c6f8ea65;
module.exports["IssueFieldValueType"] = $6e4f31abf0bf2d9f$export$2c31b482709f834f;
module.exports["IssueFieldOperation"] = $6e4f31abf0bf2d9f$export$7ea791c87396b818;
module.exports["TemplateId"] = $6e4f31abf0bf2d9f$export$9c696cb525e5ed55;
module.exports["AITemplateIds"] = $6e4f31abf0bf2d9f$export$3e6c81cf13716aea;

});

parcelRegister("jSkFe", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $881edf2ff228cef4$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    invalidValue: {
        id: "automation-extensions.smart-button.form-data.invalid-text-value.message",
        defaultMessage: "Please provide a valid value."
    },
    invalidSmartValue: {
        id: "automation-extensions.smart-button.form-data.invalid-smart-value.message",
        defaultMessage: "Please enter a properly formatted input smart value, wrapped in double curly brackets."
    },
    pageStatusNotFound: {
        id: "automation-extensions.smart-button.form-data.page-status-not-found.label",
        defaultMessage: "Page status not found"
    },
    unknownSpace: {
        id: "automation-extensions.smart-button.form-data.unknown-space.label",
        defaultMessage: "Unknown space"
    },
    sameSpaceAsTrigger: {
        id: "automation-extensions.smart-button.form-data.same-space-as-trigger.label",
        defaultMessage: "Same space as trigger"
    }
});
module.exports["i18n"] = $881edf2ff228cef4$export$a7357cdd1f0b0168;

});

parcelRegister("3IZob", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $42omo.useRef)(new Set());
    const handleDocChange = (0, $42omo.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $42omo.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});


//# sourceMappingURL=SmartButton.7d611df7.js.map
